const basico8 = {
    titulo: `JavaScript: estructura condicional switch`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Si bien podemos resolver cualquier problema utilizando solo estructuras condicionales, la estructura condicional switch puede remplazar las estructuras condicionales if anidadas cuando su condición emplea el operador de ===
La sintaxis requiere varias palabras claves de JavaScript, la veremos con un ejemplo.
Problema: Asignar a una variable un valor entre 1 y 4. Mostrar en "castellano" el número asignado. Por ejemplo si la variable almacena el 3 luego debe aparecer por pantalla "tres". Si tiene un valor que no se encuentra en el rango de 1 y 4 luego mostrar el mensaje "dato incorrecto".
<pre>
let num = 3
switch (num) {
  case 1: 
    console.log("uno")
    break
  case 2: 
    console.log("dos")
    break
  case 3: 
    console.log("tres")
    break
  case 4: 
    console.log("cuatro")
    break
  default:
    console.log("Dato incorrecto")
}
</pre>
Analiza cada caso de la estructura condicional switch y determina si coincide con alguno de los valores indicados después de la palabra clave case. Si coincide, ejecuta el bloque de código hasta encontrar la palabra clave break.
Si no coincide con ninguno de los valores indicados después de la palabra clave case, ejecuta el bloque de código que contiene el default.`,
        programa: `let num = 10
switch (num) {
  case 1: 
    console.log("uno")
    break
  case 2: 
    console.log("dos")
    break
  case 3: 
    console.log("tres")
    break
  case 4:
    console.log("cuatro")
    break
  default:
    console.log("Dato incorrecto")
}`,
        solucion: "'Dato incorrecto'",
      }, {
        codigo: 2,
        descripcion: `También funciona con variables de tipo string.`,
        programa: `let num1 = 10
let num2 = 5
let operacion = "sumar"
switch (operacion) {
  case "sumar":
    let suma = num1 + num2
    console.log("La suma es " + suma)
    break
  case "multiplicar":
    let multi = num1 * num2
    console.log("La multiplicación es " + multi)
    break;
}`,
        solucion: "'La suma es 15'",
      }, {
        codigo: 3,
        descripcion: `Se asigna a una variable un valor entero que represente un día de la semana.
Suponer que 0 corresponde a domingo, se debe mostrar el nombre del día que le corresponde.`,
        programa: `let diaSemana = 4
switch (diaSemana) {
  case 0: console.log("Domingo")
    break;
  case 1: console.log("Lunes")
    break;
  case 2: console.log("Martes")
    break;
  case 3: console.log("Miércoles")
    break;
  case 4: console.log("Jueves")
    break;
  case 5: console.log("Viernes")
    break;
  case 6: console.log("Sábado")
    break;
  default: console.log("Dato incorrecto")
}`,
        solucion: "'Jueves'",
      }, {
        codigo: 4,
        descripcion: `Cargar por asignación 3 variables numéricas que representen el día, el mes y el año.
Posteriormente mostrar con siguiente formato:  'Hoy es 25 de diciembre de 2022'`,
        programa: `let dia = 23
let mes = 8
let año = 2022
let mesNombre = ""
switch (mes) {
  case 1: mesNombre = "Enero"
    break;
  case 2: mesNombre = "Febrero"
    break;
  case 3: mesNombre = "Marzo"
    break;
  case 4: mesNombre = "Abril"
    break;
  case 5: mesNombre = "Mayo"
    break;
  case 6: mesNombre = "Junio"
    break;
  case 7: mesNombre = "Julio"
    break;
  case 8: mesNombre = "Agosto"
    break;
  case 9: mesNombre = "Septiembre"
    break;
  case 10: mesNombre = "Octubre"
    break;
  case 11: mesNombre = "Noviembre"
    break;
  case 12: mesNombre = "Diciembre"
    break;
}
let fecha = \`Hoy es \${dia} de \${mesNombre} de \${año}\`
console.log(fecha)`,
        solucion: "'Hoy es 23 de Agosto de 2022'",
      }
    ]
  }
  
  export default basico8;